<template>
    <div class="min-basket-value mb-4 mt-3" v-if="deliveryCountry == 1">
        <div v-if="percent < 100" class="text-center">
            {{ $translate("Klettershop5::Template.minBasketValueDiff") }} {{ diff | currency  }}  {{ $translate("Klettershop5::Template.minBasketValueDiffTextAfter") }}
        </div>
        <div class="mt-2 text-center color-green" v-if="percent >= 100">
            <i class="fa fa-check-circle-o mr-1"></i>{{ $translate("Klettershop5::Template.minBasketValueReached") }}
        </div>
        <div class="progress mt-2">
            <div class="progress-bar progress-bar-striped bg-success" role="progressbar" :style="'width:'+percent+'%'" :aria-valuenow="percent" aria-valuemin="0" aria-valuemax="100"></div>
        </div>

        {{ percentcalc }}
    </div>
</template>>

<script>
    export default
    {
        props: ['template','min'],
        data: function()
        {
            return{
                percent           : 0,
                itemSumNet        : 0,
                deliverycountryid : 0,
                diff:0
            }
        },
        mounted()
        {
            this.getBasketValueAndShippingId();
        },
        methods:
            {
                getBasketValueAndShippingId: function()
                {
                    let _self               = this;
                    let min                 = parseFloat(this.min)
                    _self.percent           = ((ceresStore.state.basket.data.itemSum / min) * 100);
                    _self.diff              = min-ceresStore.state.basket.data.itemSum;

                    _self.itemSumNet        =  ceresStore.state.basket.data.itemSum;
                }
            },
        computed:
            {
                deliveryCountry: function()
                {
                    return this.$store.state.basket.data.shippingCountryId
                },
                percentcalc: function()
                {
                    return this.getBasketValueAndShippingId();
                },
            }
    }
</script>
